<template>
    <div class="plugin_menu_menu">
        <div class="logo_name">
            <div class="logo_name_left">
                <div class="logo">
                    <img src="@/assets/image/qwen/logo.png" alt="" class="image">
                </div>
                <div class="title_description">
                    <div class="title">
                        <span>初新插件</span>
                    </div>
                    <div class="description">
                        <span>小红书数据获取</span>
                    </div>
                </div>
            </div>
            <div class="open_contraction">
                <MenuFoldOutlined />
            </div>
        </div>
        <div class="sidebar_menu_box">
            <a-menu mode="vertical" :selected-keys="selectedKeys" class="sidebar_menu">
                <a-menu-item key="/plugin/partnerAd" @click="onGoPath('/plugin/partnerAd')">获取数据</a-menu-item>
                <a-menu-item key="/plugin/successRecord" @click="onGoPath('/plugin/successRecord')">成功记录</a-menu-item>
                <a-menu-item key="/plugin/errRecord" @click="onGoPath('/plugin/errRecord')">错误记录</a-menu-item>
            </a-menu>
        </div>
    </div>
</template>

<script setup>
import {
    MenuFoldOutlined
} from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';

const router = useRouter();
const selectedKeys = ref(['new']);

/**
 * @function 跳转
 * @param path 
 */
const onGoPath = (path) => {
    selectedKeys.value = [path];
    router.push(path);
};

onMounted(() => {
    selectedKeys.value = [location.pathname];
});

</script>

<style lang="scss">
.plugin_menu_menu {
    width: 220px;
    height: calc(100vh);
    padding: 22px 14px 16px;
    background: #f9fafdeb;
    border-right: 1px solid #e8eaf0;

    .logo_name {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .logo_name_left {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 10px;

            .image {
                width: 36px;
                height: 36px;
                background: linear-gradient(145deg, #8069ff, #5f7cf4);
                border-radius: 12px;
                box-shadow: 0 7px 18px #6b66f538;
            }
        }

        .title_description {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;

            .title {
                font-size: 16px;
                font-weight: bold;
            }

            .description {
                font-size: 12px;
                color: #858b98;
            }
        }
    }

    .sidebar_menu_box {
        padding: 16px 0 24px 0;
        // border-bottom: 1px solid #eee;

        .sidebar_menu {
            border-right: none;
            border-inline-end: 0 !important;
            background: rgba($color: #000000, $alpha: 0);
        }
    }

    .recent_tasks {
        .recent_tasks_title {
            display: flex;
            align-content: center;
            justify-content: space-between;
            color: #777d89;
            font-size: 14px;
            padding: 16px 0;

            .icon {
                font-size: 16px;
                cursor: pointer;
            }
        }

        .two_title {
            color: #777d89;
            font-size: 14px;
            padding: 0 4px 16px;
        }

        .tasks_row {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 8px;
            font-size: 13px;
            color: #777d89;
            padding: 0 4px 16px;
        }
    }
}
</style>